"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  smallScreenMinWidth: 480,
  smallScreenMaxWidth: 768,
  mediumScreenMaxWidth: 992,
  mediumScreenMinWidth: 769,
  largeScreenMinWidth: 993
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/constants/screen-size.js
 ** module id = 818
 ** module chunks = 0
 **/